import React from "react";

const Java_LinkedList = () => {
  return (
    <div>
      <h1>Java LinkedList</h1>
      <p>This page provides explanations, examples, and common use-cases for Java LinkedList in Java.</p>
    </div>
  );
};

export default Java_LinkedList;
